import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import Swal from "sweetalert2";
import { DeactivateUser } from "../../../domain/useages/user-management/deactivate-user";
import { RemoteDeactivateUser } from "../../../data/usecases/user-management/remote-deactivate-user";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface DeactivateUserInterface {
  deactivateUser: Function;
}

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useDeactivateUserSlice: StateCreator<DeactivateUserInterface> = (
  set,
  get
) => ({
  deactivateUser: async (
    id: number,
    payload: DeactivateUser.Params,
    handleClose: Function
  ) => {
     const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
     const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteDeactivateUser = new RemoteDeactivateUser(
      `${BASE_URL}${Endpoints.DEACTIVATE_USER}`,
      axiosHttpClient
    );
    let result = await remoteDeactivateUser.deactivate(id.toString(), payload);

    if (result) {
      handleClose();
    } else {
      handleClose();
    }
  },
});
